import { clonedeep } from '@da-vinci/utils'

export function trimObjLight(data: Record<string, any>, type = ['string', 'number']) {
  const newData = clonedeep(data)
  Object.keys(newData).forEach((key) => {
    if (type.includes(typeof newData[key])) {
      newData[key] = newData[key].toString().trim()
    }
  })
  return newData
}

export function formatCount(data?: string | number) {
  const count = Number(data || 0)
  if (isNaN(count)) return `${data}`
  if (count < 10000) return `${count}`
  if (count < 10000 * 10000) return Math.floor(count / 1000) / 10 + '万'
  return Math.floor(count / (1000 * 10000)) / 10 + '亿'
}

export function getNowTimeZoneTime(time: string | number) {
  const timezoneOffset = new Date().getTimezoneOffset()
  return +time - timezoneOffset * 60 * 1000
}